<template>
  <main>
    <div class="row student barfiltre">
      <div class="col-md-12">
        <TopTemplate>
          <template #left-element>
            <h3>{{ $t("title.listStudent") }} ({{ total }})</h3>
          </template>

          <template v-if="statusSchoolYear" #right-element>
            <router-link :to="{name: 'AddStudent'}" class="btn button btn-primary" :disabled="loading">
              <i class="icon-Add" />
              {{ $t("button.addStudent") }}
            </router-link>
            <!-- <router-link :to="{name: 'AddStudentTest'}" class="btn button btn-primary" :disabled="loading">
              <i class="icon-Add" />
              {{ $t("button.addStudent") }} test
            </router-link> -->
          </template>
        </TopTemplate>

        <div class="search-date-wrapper search-filter-wrapper" :class="showFil === false ? 'borderNan' : ''">
          <div class="col-md-11 search searchStudent">
            <input v-model="params.q" type="text" placeholder="Recherche" name="search" @input="searshStudent()" />
            <img src="../../assets/icons/search-icon.svg" class="icon-search" alt="search" />
          </div>

          <div class="date-wrapper filter-wrapper" @click="showFilter()">
            <span>{{ $t("barFiltre.filtre") }}</span>
          </div>
        </div>
        <div v-if="showFil" class="row container-select container-filter">
          <div v-if="selectedLevel || selectedClass || params.datede" class="col-md-12">
            <div class="reset_student" @click="resetFilter()">
              <i class="icon-reset" />
              {{ $t("barFiltre.renitialiser") }}
            </div>
          </div>
          <div class="col-md-4 select-wrapper">
            <span class="title-select">{{ $t("barFiltre.niveau") }}</span>
            <v-select v-model="selectedLevel" :searchable="true" :options="levels" label="name" :reduce="(option) => option.id" @update:modelValue="ChangeLevel($event)">
              <template #no-options="{}">
                {{ $t("info.noResult") }}
              </template>
            </v-select>
          </div>
          <div class="col-md-4 select-wrapper">
            <span class="title-select">{{ $t("barFiltre.classe") }}</span>
            <v-select v-model="selectedClass" :searchable="true" :options="classes" label="name" :reduce="(option) => option.id" @update:modelValue="ChangeClass($event)">
              <template #no-options="{search, searching, loading}"> {{ $t("info.noResult") }}</template>
            </v-select>
          </div>
          <div v-if="!existStudent" class="col-md-4 select-wrapper">
            <span class="title-select">{{ $t("barFiltre.dateNaissance") }}</span>
            <div class="row">
              <div class="col-md-12">
                <div class="date-wrapper">
                  <Datepicker
                    v-model="params.datede"
                    autoApply
                    :enable-time-picker="false"
                    :format="format_date_v1"
                    locale="fr"
                    auto-apply
                    @update:modelValue="handleInput($event)"
                  />
                </div>
              </div>
            </div>
          </div>
          <div v-else class="col-md-4 select-wrapper">
            <span class="title-select">{{ $t("barFiltre.statut") }}</span>
            <v-select v-model="params.selectedStatus" :options="status" label="name" :reduce="(option) => option" @update:modelValue="ChangeStatus($event)">
              <template #no-options="{search, searching, loading}"> {{ $t("info.noResult") }}</template>
            </v-select>
          </div>
        </div>
      </div>
    </div>

    <div v-if="loading" class="card mt-4 text-center d-block pt-4 pb-4">
      <div class="spinner-border text-info" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div class="container-fluid empty-message">
      <div class="col-md-12">
        <div v-if="!loading && students.length === 0" class="card mt-4">
          <div class="col-12 empty-result text-center pt-3">
            <p>{{ $t("common.emptysearshStudent") }}</p>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!loading && students.length > 0" class="table list_eleve">
      <div class>
        <div class="row">
          <div class="col-md-12">
            <div class="table__wrapper table-responsive-vertical table-responsive">
              <table class="table table-responsive">
                <thead>
                  <tr>
                    <th class="check" align="left">
                      <label class="container-checkbox">
                        <input v-model="selectAll" type="checkbox" :disabled="!statusSchoolYear" />
                        <span class="checkmark checkmark__title" />
                      </label>
                    </th>
                    <th class="eleve">
                      {{ $t("eleve.tab.name") }}
                      <div class="icon-wrapper" @click="sortB('last_name')">
                        <i class="ri-arrow-up-s-line" :class="[specTri('last_name', true)]" />
                        <i class="ri-arrow-down-s-line" :class="[specTri('last_name', false)]" />
                      </div>
                    </th>
                    <th v-if="existStudent">{{ $t("eleve.tab.phone") }}</th>
                    <th>
                      {{ $t("eleve.tab.class") }}
                      <!-- <div>
                        <i @click="sort(false,'first_name')" class="ri-arrow-up-s-line" />
                        <i @click="sort(true,'first_name')" class="ri-arrow-down-s-line" />
                      </div> -->
                    </th>
                    <th v-if="!existStudent">
                      {{ $t("eleve.tab.dateNaissane") }}
                    </th>
                    <th v-if="existStudent">{{ $t("eleve.tab.status") }}</th>
                    <th>{{ $t("eleve.tab.father") }}</th>
                    <th>{{ $t("eleve.tab.mother") }}</th>
                    <th v-if="!existStudent">
                      {{ $t("eleve.tab.createdAt") }}
                      <div class="icon-wrapper" @click="sortB('created_at')">
                        <i class="ri-arrow-up-s-line" :class="[specTri('created_at', true)]" />
                        <i class="ri-arrow-down-s-line" :class="[specTri('created_at', false)]" />
                      </div>
                    </th>
                    <th class="col-xl-2 col-md-2 text-center">
                      {{ $t("common.actions") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="student in students" :key="student.id">
                    <td>
                      <label class="container-checkbox">
                        <input v-model="selected" type="checkbox" :value="student.id" :disabled="!statusSchoolYear" />
                        <span class="checkmark" />
                      </label>
                    </td>
                    <td>
                      <router-link
                        class="success_msg"
                        :to="{
                          name: 'DetailStudent',
                          params: {id: student.id},
                        }"
                      >
                        <span class="lastName_propre">{{ student.last_name }}</span
                        >&nbsp;
                        <span class="name_propre">{{ student.first_name }}</span>
                      </router-link>
                    </td>
                    <td v-if="existStudent">
                      <span v-if="student.phone">{{ student.phone }}</span
                      ><span v-else>__</span>
                    </td>
                    <td>
                      <span v-if="student.class">
                        {{ student.class.name }}
                      </span>
                      <div v-else>__</div>
                    </td>

                    <td v-if="!existStudent">
                      <div v-if="student.birthday">
                        {{ format_date_v1(student.birthday) }}
                      </div>
                      <div v-else>__</div>
                    </td>
                    <td v-if="existStudent" class="col-md-2">
                      <p>
                        <span :class="statusClass(student)"> {{ student.student_account_status === 1 ? $t("common.blocked") : statusText(student) }}</span>
                      </p>
                    </td>
                    <td>
                      <div v-if="student.parents.length > 0">
                        <div v-for="(parent, index) in student.parents" :key="index">
                          <span v-if="parent.gender === 0" class="espace_padding lastName_propre">{{ parent.last_name }} </span>
                          <span v-if="parent.gender === 0" class="espace_padding name_propre">{{ parent.first_name }}</span>
                          <span v-if="student.parents.length === 1 && parent.gender !== 0">__</span>
                        </div>
                      </div>
                      <div v-else>__</div>
                    </td>

                    <td>
                      <div v-if="student.parents.length > 0">
                        <div v-for="(parent, index) in student.parents" :key="index">
                          <span v-if="parent.gender === 1" class="espace_padding lastName_propre">{{ parent.last_name }} </span>
                          <span v-if="parent.gender === 1" class="espace_padding name_propre">{{ parent.first_name }}</span>
                          <span v-if="student.parents.length === 1 && parent.gender !== 1">__</span>
                        </div>
                      </div>
                      <div v-else>__</div>
                    </td>
                    <td v-if="!existStudent">
                      {{ moment(student.created_at).format("DD-MM-YYYY") }}
                    </td>
                    <td class="text-center">
                      <div class="espace_height">
                        <router-link
                          class="success_msg"
                          :to="{
                            name: 'DetailStudent',
                            params: {id: student.id},
                          }"
                          @click="setItem()"
                        >
                          <i class="icon-eyes">
                            <span class="tooltiptext">{{ $t("button.tooltip.details") }}</span>
                          </i>
                        </router-link>

                        <router-link
                          v-if="statusSchoolYear"
                          :to="{
                            name: 'EditStudent',
                            params: {id: student.id},
                          }"
                          @click="setItem()"
                          class
                        >
                          <i class="icon-edit-02">
                            <span class="tooltiptext">{{ $t("button.tooltip.update") }}</span>
                          </i>
                        </router-link>
                        <!-- <i v-if="statusSchoolYear" class="icon-trash" @click.prevent="deleteStudent(student.id)">
                          <span class="tooltiptext">{{ $t("button.tooltip.delete") }}</span>
                        </i> -->
                        <i class="icon-forbiden" @click.prevent="blocageStudentFn(student)">
                          <span class="tooltiptext">{{ $t("button.tooltip.blocage") }}</span>
                        </i>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="col-md-12">
                <div class="table__wrapper__pagination-wrapper">
                  <div class="pagination">
                    <pagination v-if="last_page > 1" :data-set="pagination" @goToPage="getResults" />
                  </div>
                </div>
              </div>

              <!-- <div >
                <div class="row">
                <div class="col-md-12 delete-all-student">
                  <div class="button-delete">
                    <button @click.prevent="deleteSelected" class="btn btn-outline-primaryy button"
                      :disabled="selected.length == 0 ? true : false">
                      <span class="delete"> Supprimer</span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="table__wrapper__pagination-wrapper">
                <div class="pagination">
                  <pagination :dataSet="pagination" @goToPage="getResults" />
                </div>
              </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!loading" class="modal_dis">
      <div v-if="statusSchoolYear" class="delete-all-student">
        <div class="button-class" :class="{notselected: selected.length === 0}">
          <button class="btn button btn-primary btn-effect" :disabled="selected.length == 0" @click="pushData(), (showModal = true)">Affecter à une classe</button>
        </div>
      </div>
    </div>

    <!-- <div v-if="!loading" class="modal_dis">
      <div v-if="statusSchoolYear" class="delete-all-student">
        <div class="button-delete">
          <button class="btn btn-danger button" :disabled="selected.length == 0" @click.prevent="deleteSelected"><i class="icon-trash" /> {{ $t("button.delete") }}</button>
        </div>
        <div class="button-class" :class="{notselected: selected.length === 0}">
          <button class="btn button btn-primary btn-effect" :disabled="selected.length == 0" @click="pushData(), (showModal = true)">Affecter à une classe</button>

         
          <input type="checkbox" id="toggle" class="toggle-input">
          <label for="toggle" class="toggle-label btn button btn-primary">Actions <i class="arrow down"></i></label>
          <ul class="list">
            <button class="btn  button custom-btn" :disabled="selected.length == 0" @click="pushData() , showModal = true">
              Affecter à une classe
            </button>
      
          </ul>
        </div>
      </div>
    </div> -->
    <div v-if="showModal" class="modal-vue">
      <div class="overlay"></div>

      <div class="modal-edition">
        <div class="titre-parent titre-class_modal">
          <h3>Affecter à une classe</h3>
          <button class="close" @click="hideModal()">
            <i class="icon-Add" />
          </button>
        </div>
        <form @submit.prevent="addClassAffecte()" novalidate autocomplete="off">
          <div class="spec-inputs">
            <div class="row justify-content-center">
              <div class="col-md-10 select-wrapper custom-padding">
                <v-select
                  v-model="selectedLevel2"
                  :searchable="true"
                  :options="levels2"
                  label="name"
                  :class="{'is-invalid': v$.selectedLevel2.$error}"
                  :reduce="(option) => option.id"
                  @update:modelValue="ChangeLevel2($event)"
                  placeholder="Niveau*"
                >
                  <template #no-options="{search, searching, loading}">
                    {{ $t("info.noResult") }}
                  </template>
                </v-select>
                <span v-if="v$.selectedLevel2.$error && !notEroor" class="invalid-feedback">{{ v$.selectedLevel2.$errors[0].$message }}</span>
              </div>
              <div class="col-md-10 select-wrapper custom-padding">
                <v-select
                  v-model="selectedClass2"
                  :searchable="true"
                  :options="classes2"
                  label="name"
                  :class="{'is-invalid': v$.selectedClass2.$error}"
                  :reduce="(option) => option.id"
                  placeholder="Classe*"
                >
                  <template #no-options="{search, searching, loading}"> {{ $t("info.noResult") }}</template>
                </v-select>
                <span v-if="v$.selectedClass2.$error && !notEroor" class="invalid-feedback">{{ v$.selectedClass2.$errors[0].$message }}</span>
              </div>
              <div class="col-12 buttons bloc-btn">
                <div class="button-left">
                  <button type="button" class="btn btn-outline-primary button cancel" :disabled="loading" @click="hideModal()">
                    <i class="icon-Add" />
                    {{ $t("button.annuler") }}
                  </button>
                </div>
                <div class="button-right d-flex">
                  <button type="submit" class="btn button btn-primary" :disabled="loading">
                    <i class="icon-Check" />
                    {{ $t("button.save") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </main>
</template>

<script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import StudentService from "../../services/student.service";
import pagination from "../../components/navigation/Pagination";
import vSelect from "vue-select";
import moment from "moment";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import useValidate from "@vuelidate/core";
import {required, helpers} from "@vuelidate/validators";
import {mapGetters, mapActions} from "vuex";

import _ from "lodash";
import {ref, onMounted} from "vue";
export default {
  name: "StudentsList",
  components: {
    TopTemplate,
    pagination,
    "v-select": vSelect,
    Datepicker,
  },
  setup() {
    // In case of a range picker, you'll receive [Date, Date]
    const format = (due_date) => {
      const day = due_date.getDate();
      const month = due_date.getMonth() + 1;
      const year = due_date.getFullYear();
      if (day <= 9) {
        return `0${day}/${month}/${year}`;
      }
      if (day > 9) {
        return `${day}/${month}/${year}`;
      }
      if (month <= 9) {
        return `0${day}/0${month}/${year}`;
      } else {
        return `${day}/${month}/${year}`;
      }
    };
    // For demo purposes assign range from the current date
    const date = ref();

    onMounted(() => {
      const startDate = new Date();
      const endDate = new Date(new Date().setDate(startDate.getDate() + 7));
      date.value = [startDate, endDate];
    });

    return {
      format,
      date,
    };
  },
  data() {
    return {
      v$: useValidate(),
      showModal: false,
      loading: false,
      pagination: {},
      total: 0,
      classes: [],
      levels: [],
      classes2: [],
      levels2: [],
      datea: null,
      readInput: true,
      showFil: false,
      params: {
        q: "",
        limit: 15,
        page: 1,
        sort: "",
        order: false,
        class_type_id: [],
        class_school_id: [],
        birthday: null,
        datede: null,
        selectedStatus: null,
      },
      status: [
        {
          id: 1,
          value: "registred",
          name: "Enregistré",
        },
        {
          id: 2,
          value: "not_registred",
          name: "Non enregistré",
        },
      ],
      last_page: null,
      selectedLevel: null,
      selectedClass: null,
      selectedLevel2: null,
      selectedClass2: null,
      notEroor: false,
      students: [],
      selected: [],
      moment: null,
      existStudent: false,
      selectedStatus: null,
      pageDetail: null,
      passageYears: null,
    };
  },
  validations() {
    return {
      selectedClass2: {
        required: helpers.withMessage(this.$t("validation.required"), required),
      },
      selectedLevel2: {
        required: helpers.withMessage(this.$t("validation.required"), required),
      },
    };
  },
  computed: {
    ...mapGetters(["getPassageYears"]),
    statusClass() {
      return (student) => {
        if (student.student_account_status == 1) {
          return "blocked_status";
        }
        return student.status === 1 ? "active_status" : "noActive_status";
      };
    },
    statusText() {
      return (student) => {
        return student.status === 1 ? this.$t("common.save") : this.$t("common.noSave");
      };
    },
    statusSchoolYear() {
      return this.getPassageYears.status;
    },
    selectAll: {
      get: function () {
        return this.students ? this.selected.length == this.students.length : false;
      },
      set: function (value) {
        let selected = [];

        if (value) {
          this.students.forEach(function (student) {
            selected.push(student.id);
          });
        }

        this.selected = selected;
      },
    },
    userModules() {
      return this.$store.state?.auth?.user?.modules;
    },
  },
  watch: {
    getPassageYears(val) {
      if (val.id) {
        this.selectedLevel = null;
        this.selectedLevel2 = null;
        this.selectedClass2 = null;
        this.notEroor = true;
        this.params.class_type_id = [];
        this.selectedClass = null;
        this.params.class_school_id = [];
        this.params.selectedStatus = null;
        this.selectedStatus = null;
        this.params.datede = null;
        this.passageYears = val.id;
        this.FilterStudents();
        this.ListStudents();
      }
    },
  },
  created() {
    this.moment = moment;
    this.pageDetail = localStorage.getItem("detail");
    if (this.getPassageYears.id) {
      this.passageYears = this.getPassageYears.id;
      this.FilterStudents();
      this.ListStudents();
    }
    this.moduleUser();
  },

  methods: {
    ...mapActions(["blocageStudent"]),
    pushData() {
      this.selectedLevel2 = this.selectedLevel;
    },
    setItem() {
      localStorage.setItem("detail", true); // Ajout de la page courante dans le localStorage
    },
    clearSavedPage() {
      localStorage.removeItem("detail"); // Suppression de l'élément du localStorage
    },

    hideModal() {
      this.showModal = false;
      this.selected = [];
      this.selectedLevel2 = null;
      this.selectedClass2 = null;
      this.v$.$reset();
      const checkbox = document.getElementById("toggle");
      if (checkbox) {
        checkbox.checked = false;
      }
    },
    addClassAffecte() {
      this.notEroor = false;
      const class2 = this.selectedClass2;
      const data = {
        students_ids: this.selected,
        class_id: this.selectedClass2,
      };
      this.v$.$validate();
      if (!this.v$.$error) {
        StudentService.addClass(data)
          .then((response) => {
            this.selectedLevel2 = null;
            this.selectedClass2 = null;
            this.v$.$reset();
            this.FilterStudents();
            this.getResults();
            this.selected = [];
            const checkbox = document.getElementById("toggle");
            if (checkbox) {
              checkbox.checked = false;
            }
            this.showModal = false;
            const Swal2 = require("sweetalert2");
            const swalWithBootstrapButtons2 = Swal2.mixin({
              customClass: {
                confirmButton: "btn btn-confirm  btn-primary",
                cancelButton: "btn  btn-cancel  btn-outline-primary",
              },
              buttonsStyling: false,
              showCloseButton: true,
            });
            //const index = this.students.findIndex(items => items.id === id);
            swalWithBootstrapButtons2.fire({
              title: `Les élèves ont été affectés à la classe avec succès.`,
              icon: "warning",
              showCloseButton: true,
              showCancelButton: false,
              confirmButtonText: this.$t("common.ok"),
              cancelButtonText: this.$t("common.noCancel"),
              reverseButtons: true,
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    format_date_v1(value) {
      if (value) {
        return moment(String(value)).format("DD-MM-YYYY");
      }
    },
    ChangeStatus(e) {
      this.params.selectedStatus = e ? e.name : null;
      this.selectedStatus = e ? e.value : null;
      this.getResults();
      this.params.hasfilter = true;
    },
    resetFilter() {
      this.selectedLevel = null;
      this.selectedLevel2 = null;
      this.selectedClass2 = null;
      this.notEroor = true;
      this.params.class_type_id = [];
      this.selectedClass = null;
      this.params.class_school_id = [];
      this.params.selectedStatus = null;
      this.selectedStatus = null;
      this.params.datede = null;
      this.FilterStudents();
      this.getResults();
    },

    checkIfElementNameIsEleves() {
      return this.userModules.some((element) => element.name === this.$t("modules.student"));
    },
    moduleUser() {
      this.existStudent = this.checkIfElementNameIsEleves();
    },
    specTri(param, order) {
      if (this.params.order === null && this.params.sort === "") {
        return "";
      } else {
        if (this.params.sort === param) {
          if (this.params.order === order) {
            return "ordredA";
          } else {
            return "ordredD";
          }
        } else {
          return "";
        }
      }
    },
    sortB: _.debounce(function (param) {
      this.params.order = this.params.order === false ? true : false;
      this.params.sort = param;
      this.ListStudents();
    }, 200),
    sort(order, sort) {
      this.params.order = order;
      this.params.sort = sort;
      this.ListStudents();
    },
    showFilter() {
      this.showFil = !this.showFil;
    },
    dateTime(value) {
      return moment(value).locale("fr").format("YYYY-MM-DD");
    },
    deleteStudent(id) {
      const Swal = require("sweetalert2");
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-confirm  btn-primary",
          cancelButton: "btn  btn-cancel  btn-outline-primary",
        },
        buttonsStyling: false,
        showCloseButton: true,
      });
      //const index = this.students.findIndex(items => items.id === id);
      swalWithBootstrapButtons
        .fire({
          title: this.$t("common.confirmDeleteStudent"),
          icon: "warning",
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: this.$t("common.deletIT"),
          cancelButtonText: this.$t("common.noCancel"),
          reverseButtons: true,
        })
        .then((result) => {
          this.selected = [];
          if (result.isConfirmed) {
            swalWithBootstrapButtons.fire(this.$t("common.studentDeleted"), "", "success");
            StudentService.delete(id).then(
              () => {
                this.students = [];
                this.getResults();
              },
              (error) => {
                this.loading = false;
              }
            );

            //window.location.href = '/eleves';
            //this.goBack();
            //this.$router.push('/eleves')
          }
        });
    },
    blocageStudentFn(student) {
      const Swal = require("sweetalert2");
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-confirm  btn-primary",
          cancelButton: "btn  btn-cancel  btn-outline-primary",
        },
        buttonsStyling: false,
        showCloseButton: true,
      });
      swalWithBootstrapButtons
        .fire({
          title:
            student.student_account_status == 0 || student.student_account_status == null ? this.$t("common.confirmBlockedStudent") : this.$t("common.confirmdeblockedStudent"),
          icon: "warning",
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: this.$t("common.deletIT"),
          cancelButtonText: this.$t("common.noCancel"),
          reverseButtons: true,
        })
        .then((result) => {
          this.selected = [];
          if (result.isConfirmed) {
            const params = {
              id: student.id,
              payload: {
                status: student.student_account_status == 0 || student.student_account_status == null ? 1 : 0,
              },
            };
            this.blocageStudent(params).then(
              () => {
                const status = student.student_account_status == 0 || student.student_account_status == null ? 1 : 0;
                swalWithBootstrapButtons.fire(status == 0 ? this.$t("common.studentDeblcoked") : this.$t("common.studentBlocked"), "", "success");
                this.getResults();
              },
              (error) => {
                this.loading = false;
              }
            );
          }
        });
    },
    deleteSelected() {
      const Swal = require("sweetalert2");
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-confirm  btn-primary",
          cancelButton: "btn  btn-cancel  btn-outline-primary",
        },
        buttonsStyling: false,
        showCloseButton: true,
      });
      swalWithBootstrapButtons
        .fire({
          title: this.$t("common.confirmDeleteSelectedStudent"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: this.$t("common.deletIT"),
          cancelButtonText: this.$t("common.noCancel"),
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            swalWithBootstrapButtons.fire(this.$t("common.studentSelectedDeleted"), "", "success");
            StudentService.deleteAll({
              params: {
                studentsId: this.selected,
              },
            }).then(
              () => {
                this.students = [];
                this.getResults();
              },
              (error) => {
                this.loading = false;
              }
            );
          }
        });
    },
    makePagination(meta, links) {
      return {
        current_page: meta.current_page,
        last_page: meta.last_page,
        next_page_url: links.next,
        prev_page_url: links.prev,
      };
    },
    ChangeLevel(e) {
      this.params.class_type_id = [];
      this.params.class_school_id = [];
      this.selectedClass = null;
      if (e) {
        this.params.class_type_id = [e];
      }
      this.FilterStudents();
      this.getResults();
    },
    ChangeLevel2(e) {
      if (e) {
        this.params.class_type_id = [];
        this.params.class_type_id.push(e);
      } else {
        this.params.class_type_id = [];
      }
      this.FilterStudents();
    },
    ChangeClass(e) {
      if (e) {
        this.params.class_school_id = [];
        this.params.class_school_id.push(e);
      } else {
        this.params.class_school_id = [];
      }
      this.getResults();
    },
    handleInput() {
      this.readInput = false;
      if (this.params.datede != null) {
        this.params.datede = this.dateTime(this.params.datede);
      }
      this.getResults();
    },
    FilterStudents() {
      StudentService.getFilter({
        params: {
          type_id: this.params.class_type_id,
          school_year: this.passageYears,
        },
      }).then(
        (response) => {
          this.levels = response.data.types;
          this.classes = response.data.classes;
          this.levels2 = response.data.types;
          this.classes2 = response.data.classes;

          //  this.loading = false;
        },
        (error) => {
          this.loading = false;
        }
      );
    },
    ListStudents() {
      this.loading = true;
      StudentService.getAll({
        params: {
          q: this.params.q,
          limit: this.params.limit,
          sort: this.params.sort,
          order: this.params.order,
          class_school_id: this.params.class_school_id,
          class_type_id: this.params.class_type_id,
          // birthday: this.params.birthday
          birthday: this.params.datede,
          status: this.selectedStatus,
          school_year: this.passageYears,
        },
      })
        .then((response) => {
          this.students = response.data.data;
          const savedPage = localStorage.getItem("currentPage");

          if (savedPage && this.pageDetail) {
            this.params.page = Number(savedPage);
            this.getResults(null, this.params.page);
          }
          this.pagination = this.makePagination(response.data.meta, response.data.links);
          this.total = response.data.meta.total;
          this.last_page = response.data.meta.last_page;
          this.loading = false;
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
          this.clearSavedPage();
        });
    },
    getResults(page = null, param) {
      //this.selected = [];
      if (param) {
        this.params.page = param;
      } else {
        this.params.page = !page ? this.params.page : page;
      }

      localStorage.setItem("currentPage", this.params.page); // Ajout de la page courante dans le localStorage
      this.loading = true;
      StudentService.getAll({
        params: {
          q: this.params.q,
          limit: this.params.limit,
          page: this.params.page,
          sort: this.params.sort,
          order: this.params.order,
          status: this.selectedStatus,
          class_school_id: this.params.class_school_id,
          class_type_id: this.params.class_type_id,
          //  birthday: this.params.birthday
          birthday: this.params.datede,
          school_year: this.passageYears,
        },
      }).then(
        (response) => {
          this.students = response.data.data;
          this.pagination = this.makePagination(response.data.meta, response.data.links);
          this.total = response.data.meta.total;
          this.loading = false;
        },
        (error) => {
          this.loading = false;
        }
      );
    },
    searshStudent: _.debounce(function () {
      if (this.params.q.toString().length > 1 || !this.params.q.toString().length) {
        this.params.hasfilter = true;
        this.ListStudents();
      }
    }, 200),
  },
};
</script>

<style scoped>
.notselected {
  opacity: 0.5;
  pointer-events: none;
}
.button-rdv button {
  background-color: #377879;
}

.custom-padding {
  margin-bottom: 15px;
}

.titre-class_modal h3 {
  font-size: 16px;
  font-weight: 700;
  line-height: 23px;
  letter-spacing: 0px;
  text-align: left;
  color: #34b9bb;
}

.bloc-btn {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
  margin-bottom: 10px;
}

.bloc-btn .cancel i {
  transform: rotate(45deg);
}

.v-select,
.v-select * {
  height: 40px;
}

input#toggle {
  opacity: 0;
}

.custom-btn {
  box-shadow: 0px 4px 7px -6px #b0b0b040;
  background: white;
  margin-top: 5px;
  padding: 15px;
  margin-left: 0;
}

.spec-inputs {
  margin-top: 10px;
}

/* Styles de base pour le bouton bascule */
/* Styles pour le bouton */
.toggle-label,
.btn-effect {
  background-color: #377879;
  border-color: #377879;
}

i.arrow.down {
  margin-left: 10px;
  margin-bottom: 5px;
  border-color: white;
}

/* Styles pour la liste (cachée par défaut) */
.list {
  list-style: none;
  padding: 0;
  display: none;
}

/* Styles pour afficher la liste lorsque le bouton est coché */
.toggle-input:checked ~ .list {
  display: block;
}
.delete-all-student {
  display: flex;
}
.button-class {
  margin-top: 0px;
  margin-left: 15px;
}
.toggle-label.button.btn-primary:hover {
  border-color: #377879;
  background-color: #377879;
  color: white !important;
}
.btn-effect:hover {
  background-color: transparent !important;
  color: #377879 !important;
  border-color: #377879 !important;
}
.delete-all-student .button-delete {
  margin-top: auto !important;
}

.button-delete {
  margin-bottom: 20px !important;
}
.empty-message {
  padding: 0;
  margin-bottom: 10px;
}
</style>
